import axios from "axios";
import { store } from "../../Redux/store";
import { API_BASE_URL, APPLICATION_NAME } from "../Constant";
// import { openLoginModal } from "../../Redux/Action/login.action";
import { tokenExpired } from "../../Redux/Action/token.action";
import LocalStorageService from "./AuthServiceStorage";

/* Abstraction of the methods in Auth Service Constants */
const localService = LocalStorageService.getService();

/* -- Start of Axios Interceptors for Data Apis -- */
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use((request) => requestHandler(request));

/* Setting the headers for axios request */
const requestHandler = (request) => {
  request.headers["token"] = localService.getAccessToken();
  return request;
};
/* -- End of Axios Interceptors for Data Apis -- */

/* -- Start of Axios Interceptors for Authentication Apis -- */
const authAxiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

/* -- End of Axios Interceptors for Authentication Apis -- */

/* -- Start of Api requests -- */
var refreshing = false;
let refreshSubscribers = [];

axiosInstance.interceptors.response.use(null, async (error) => {
  if (error.config && error.response && error.response.status === 400) {
    const handleRefreshLogic = async (data) => {
      if (data.status === 400) {
        if (!refreshing) {
          refreshing = true;
          onRefreshToken()
            .then((newToken) => {
              refreshing = false;
              onRrefreshed(newToken);
              refreshSubscribers = [];
            })
            .catch((error) => {
              refreshing = false;
            });
        }

        return new Promise((resolve, reject) => {
          subscribeTokenRefresh((token) => {
            // Remove the old token header before retrying
            delete error.config.headers["token"];
            // Retry the request and allow interceptor to set the new token
            resolve(axiosInstance.request(error.config));
          });
        });
      } else {
        return Promise.reject(error);
      }
    };

    if (error.response.data instanceof Blob) {
      const blob = new Blob([error.response.data]);
      const data = JSON.parse(await blob.text());
      return handleRefreshLogic(data);
    } else {
      return handleRefreshLogic(error.response.data);
    }
  }

  if (error.config && error.response && error.response.status === 401) {
    // store.dispatch(openLoginModal());
    return Promise.reject(error);
  }

  return Promise.reject(error);
});

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

function onRrefreshed(token) {
  // Notify all subscribers with the new token
  refreshSubscribers.map((cb) => cb(token));
}

/* Api request to fetch the data */
export const dataDisplayRequest = async (config) => {
  return await axiosInstance.request(config).then((response) => {
    return Promise.resolve(response);
  });
};

/* Api request to fetch refresh token */
export const onRefreshToken = () => {
  const params = {
    accessToken: localService.getAccessToken(),
    refreshToken: localService.getRefreshToken(),
    grantType: "refresh_token",
  };

  const refreshConfig = {
    url: "api/v1/oauth/getAccessToken",
    method: "post",
     params,
  };

  return authAxiosInstance
    .request(refreshConfig)
    .then(async (response) => {
      localService.setToken(response.data); // <-- Make sure this stores the new access token
      localService.setAuthDetails(JSON.stringify(response.data));
      return Promise.resolve(response.data.accessToken);
    })
    .catch((error) => {
      switch (error.response?.status) {
        case 401:
          // store.dispatch(openLoginModal());
          store.dispatch(tokenExpired());
          window.location.href = `/${APPLICATION_NAME}/login`
          return Promise.reject(error);
        default:
          return Promise.reject(error);
      }
    });
};

/* Api request for login */
export const authLogin = (config) => {
  return authAxiosInstance
    .request(config)
    .then((response) => {
      const data = response.data;
      localService.setToken(data);
      localService.setAuthDetails(JSON.stringify(data));
      // store.dispatch(closeModal());
      return Promise.resolve(response.data);
    })
    .catch(async (error) => {
      return Promise.reject(error);
    });
};

/* Api request for Logout */
export const authLogout = (config) => {
  return authAxiosInstance
    .request(config)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch(async (error) => {
      return Promise.reject(error);
    });
};

export const isValidToken = (message) => {
  return message !== "Invalid Token: null";
};
